import React, { Component } from 'react'

export default class Mark extends Component {
  render() {
    return (
      <div className='Mark'>
        <span>From AK_</span>
      </div>
    )
  }
}
